import { useState, useEffect } from "react";

const useFetchCsrfToken = () => {
  const [csrfToken, setCsrfToken] = useState("");

  useEffect(() => {
    const fetchCSRFToken = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_API}api/csrf_token/`,
          {
            credentials: "include",
          },
        );
        const data = await response.json();
        setCsrfToken(data.csrfToken);
      } catch (error) {
        console.error("Error fetching CSRF token:", error);
      }
    };

    fetchCSRFToken();
  }, []); // Fetch only once on mount

  return csrfToken;
};

export default useFetchCsrfToken;
